module.exports = __webpack_public_path__ + "static/media/logo.282d826b.png";